import { render, staticRenderFns } from "./AddTeamsModal.vue?vue&type=template&id=603920de&scoped=true"
import script from "./AddTeamsModal.vue?vue&type=script&lang=js"
export * from "./AddTeamsModal.vue?vue&type=script&lang=js"
import style0 from "./AddTeamsModal.vue?vue&type=style&index=0&id=603920de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603920de",
  null
  
)

export default component.exports